import contact_page from '../pages/api/localData/ContactUs.json';
import ContactUs from '../components/sections/contactUs/ContactUs';
import classes from '../styles/Page.module.scss';

/**
 * Simfy Web Home Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const ContactPage = () => {
    const { contact_us } = contact_page?.contact_page;
    return (
        <div className={classes.oPage}>
            <ContactUs {...contact_us} />
        </div>
    );
};

export default ContactPage;
